var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCloseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1999 0.399902C4.53716 0.399902 3.9999 0.937161 3.9999 1.5999V2.7999H2.7999C1.47442 2.7999 0.399902 3.87442 0.399902 5.1999V17.1999C0.399902 18.5254 1.47442 19.5999 2.7999 19.5999H17.1999C18.5254 19.5999 19.5999 18.5254 19.5999 17.1999V5.1999C19.5999 3.87442 18.5254 2.7999 17.1999 2.7999H15.9999V1.5999C15.9999 0.937161 15.4626 0.399902 14.7999 0.399902C14.1372 0.399902 13.5999 0.937161 13.5999 1.5999V2.7999H6.3999V1.5999C6.3999 0.937161 5.86264 0.399902 5.1999 0.399902ZM7.72914 7.77073C7.32641 7.36801 6.67346 7.36801 6.27073 7.77073C5.86801 8.17346 5.86801 8.82641 6.27073 9.22914L8.54153 11.4999L6.27073 13.7707C5.86801 14.1735 5.86801 14.8264 6.27073 15.2291C6.67346 15.6319 7.32641 15.6319 7.72914 15.2291L9.99994 12.9583L12.2707 15.2291C12.6735 15.6319 13.3264 15.6319 13.7291 15.2291C14.1319 14.8264 14.1319 14.1735 13.7291 13.7707L11.4583 11.4999L13.7291 9.22914C14.1319 8.82641 14.1319 8.17346 13.7291 7.77073C13.3264 7.36801 12.6735 7.36801 12.2707 7.77073L9.99994 10.0415L7.72914 7.77073Z",
    fill: "#399B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCloseGreen);
export default __webpack_public_path__ + "static/media/calendar-close-green.a962002edf2e15d2283ed5a50f805c4d.svg";
export { ForwardRef as ReactComponent };